import React from 'react';
import { number, object } from 'prop-types';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import { isValidCalculator } from '../../../../utils/calculator';
import { getFormattedLabel } from '../../../../utils/translation/pricingFactors/label';
import PackageCalculator from '../../PackageCalculator';

import './style.scss';

const PackageContentCalculator = ({ calculator, packageId }, { general: { subCategoryId } }) => {
    if (!isValidCalculator(calculator)) {
        return null;
    }

    const getCalculatorFormattedLabel = (i18n) => {
        const { name, type, value } = calculator;

        return getFormattedLabel(i18n, name, type, value, subCategoryId);
    };

    return (
        <div className="calculator">
            <I18nProvider>
                {({ i18n }) => (
                    <label>{getCalculatorFormattedLabel(i18n)}</label>
                )}
            </I18nProvider>
            <PackageCalculator packageId={packageId} {...calculator}/>
        </div>
    );
};

PackageContentCalculator.propTypes = {
    packageId: number,
    calculator: object
};

PackageContentCalculator.contextTypes = {
    general: object
};

export default PackageContentCalculator;
